import { LOCAL_STORAGE_KEYS } from 'utils/constants/localStorageKeys';
import { safeJsonParse } from './safeJsonParse';

export const getLocalStorageUser = () => safeJsonParse(localStorage.getItem(LOCAL_STORAGE_KEYS.USER));
